import { useCallback } from "react";
import { useQuery, useMutation } from "./urqlHooks";
import { useSelectedCompanyId } from "./tenantCompanyId";

const BANK_ACCOUNT = `
query bankPasswors($companyId: String!) {
    bankPasswords(companyId: $companyId) {
      id
      name
      templateId
      isActive
      currencyType
      accountNumber
    }
  }  
`;

export const GetBankAccounts = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: BANK_ACCOUNT,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const REFETCH_BANK_DATA = `mutation REFETCH_BANK_DATA($companyId: String!) {
  refetchBankData(companyId: $companyId)
}`;

export const RefetchBankData = () => {
  const [result, reexecuteQuery] = useMutation(REFETCH_BANK_DATA);
  return { result, reexecuteQuery };
};

const REFETCH_BANK_DATA_BY_ID = `mutation REFETCH_BANK_DATA_BY_ID($id: String!, $companyId: String!) {
  refetchBankDataById(id: $id, companyId: $companyId)
}`;

export const RefetchBankDataById = () => {
  const selectedCompanyId = useSelectedCompanyId();
  const [result, reexecuteQuery] = useMutation(REFETCH_BANK_DATA_BY_ID);
  const wrapped = useCallback(
    (vars) => reexecuteQuery({ ...vars, companyId: vars?.companyId || selectedCompanyId }),
    [reexecuteQuery, selectedCompanyId],
  );
  return { result, reexecuteQuery: wrapped };
};
